import React, { Component } from "react";
import { Link } from "react-router-dom";
import routes from '../routes/sidebar-links';
import "./sidebarNav.css";
export default class SidebarNav extends Component {
  render() {
    return (
      <div className="list-group list-group-flush ">
        {routes.map((route,index) => (
          <Link 
          key={index}
          to={route["path"]}
          className="list-group-item list-group-item-action bg-primary-theme text-light"
        >
          <i style={{color:'white'}} className={route["icon"]}></i> {route["title"]}
        </Link>
        ))}

      </div>
    );
  }
}
